// extracted by mini-css-extract-plugin
export default {"popup":"Select_popup__ahPeZ"};